import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.5 11.5L12.5 5.5M12.5 5.5L6.5 11.5M12.5 5.5L12.5 20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round" }));
export default SvgArrowUp;
